/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseTrianglesHClosedIcon20Solid = forwardRef('ArrowCollapseTrianglesHClosedIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m4.536 4.786 3.977 3.976a1.75 1.75 0 0 1 0 2.475l-3.977 3.976C3.97 15.78 3 15.38 3 14.577V5.423c0-.802.97-1.204 1.536-.637Z" }),
        React.createElement("path", { d: "m15.464 4.786-3.977 3.976a1.75 1.75 0 0 0 0 2.475l3.977 3.976c.567.567 1.536.166 1.536-.636V5.423c0-.802-.97-1.204-1.536-.637Z" })));
});
